import { Link } from 'react-router-dom';

import { Icon, Stack, Text } from '@eluve/components';

/**
 * Settings row that drills into a sub-page: title (with optional supporting
 * copy) on the left, chevron on the right. Renders a router link so drill-in
 * pages stay deep-linkable.
 */
export const SettingsDrillRow = ({
  title,
  description,
  to,
}: {
  title: string;
  description?: string;
  to: string;
}) => (
  <Link
    to={to}
    className="flex w-full items-center justify-between gap-4 px-6 py-7 text-left transition-colors hover:bg-bg-tertiary"
  >
    <Stack gap={0.5} className="min-w-0 flex-1">
      <Text size="sm" weight="medium" color="primary">
        {title}
      </Text>
      {description != null && (
        <Text size="xs" weight="medium" color="tertiary">
          {description}
        </Text>
      )}
    </Stack>
    <Icon name="ChevronRight" className="shrink-0 text-text-tertiary" />
  </Link>
);
